import {
  GET_MULTIPLE_LMT_HEADER_REQUEST,
  GET_MULTIPLE_LMT_HEADER_SUCCESS,
  GET_MULTIPLE_LMT_HEADER_FAILURE,
} from 'Store/constants';
  
const initialState = {
  data: {},
  isLoading: null,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MULTIPLE_LMT_HEADER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MULTIPLE_LMT_HEADER_SUCCESS:
      return {
        data: {
          ...state.data,
          [action.payload.eventId]: action.payload,
        },
        isLoading: false,
        error: null,
      };
    case GET_MULTIPLE_LMT_HEADER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};